import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToastComponent } from './toast.component';
import { ToastOverlayComponent } from './toast-overlay.component';
import { ElementsModule } from '@shared/elements/elements.module';

@NgModule({
    imports: [
      CommonModule,
      TranslateModule,
      OverlayModule,
      ElementsModule
    ],
    exports: [
        ToastComponent
    ],
    declarations: [
        ToastOverlayComponent,
        ToastComponent
    ],
})
export class ToastComponentModule {}